// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__qAHJ2","available":"Button_available__3TPAW"};